import React from 'react';
import { useSelector } from 'react-redux';
import Team from './Team'
import './TeamList.css';
import ColorLegend from '../planning/ColorLegend';
import * as ResourceStore from '../../store/ResourceStore';
import moment from 'moment';

const CustomTeamList = () => {
    const units = useSelector((state) => state[ResourceStore.reducerName].units);
    const bookings = useSelector((state) => state[ResourceStore.reducerName].bookings);
    const teams = useSelector((state) => state.teamState.teams);

    const now = moment();
    const currentBookings = bookings.filter((x) => now.isSameOrAfter(moment(x.startTime)) && now.isSameOrBefore(moment(x.endTime)));

    if(teams.length < 1) return null;

    const addUnits = (team) => {
        if (!team) return;
        const unitsForTeam = currentBookings.reduce((result, b) => {
            if (b.teamId === team.id) {
                const unit = units.find((u) => u.id === b.unitId);
                if (unit) result.push(unit);
            }
            return result;
        }, []);
        return { ...team, units: unitsForTeam };
    };

    const administration = teams.find((x) => x.id === 137);
    addUnits(administration);

    const gartner = teams.find((x) => x.id === 138);
    addUnits(gartner);

    const broendbyOester = teams.find((x) => x.id === 139);
    addUnits(broendbyOester);

    const broendbyVester = teams.find((x) => x.id === 140);
    addUnits(broendbyVester);

    const broendbyStrand = teams.find((x) => x.id === 141);
    addUnits(broendbyStrand);

    const skovGraes = teams.find((x) => x.id === 151);
    addUnits(skovGraes);

    const idraet = teams.find((x) => x.id === 152);
    addUnits(idraet);

    const vej = teams.find((x) => x.id === 142);
    addUnits(vej);

    const entreprenoer = teams.find((x) => x.id === 143);
    addUnits(entreprenoer);

    const skiltevogn = teams.find((x) => x.id === 144);
    addUnits(skiltevogn);

    const graes = teams.find((x) => x.id === 145);
    addUnits(graes);

    const rotter = teams.find((x) => x.id === 146);
    addUnits(rotter);

    const baeredygtighed = teams.find((x) => x.id === 147);
    addUnits(baeredygtighed);

    const vaerksted = teams.find((x) => x.id === 148);
    addUnits(vaerksted);

    const genbrugsstation = teams.find((x) => x.id === 149);
    addUnits(genbrugsstation);

    const renhold = teams.find((x) => x.id === 150);
    addUnits(renhold);

    return (
        <div className="team-list">
            {gartner &&
                <Team 
                    team={gartner} 
                    width={30}
                    subTeams={[broendbyVester, broendbyStrand, skovGraes, idraet]}
                />
            }
            {vej && 
                <Team 
                    team={vej} 
                    width={35}
                    subTeams={[skiltevogn, graes, rotter, renhold]}
                />
            }
            {administration &&
                <Team
                    team={administration}
                    width={35}
                    height={35}
                />
            }
            {baeredygtighed &&
                <Team 
                    team={baeredygtighed} 
                    width={35} 
                    height={64.3}
                    subTeams={[genbrugsstation]}
                />
            }
            <ColorLegend isHomePage={true} />
        </div>
    );
};

export default CustomTeamList;